import { render, staticRenderFns } from "./AccountAff.vue?vue&type=template&id=089273a2&scoped=true&"
import script from "./AccountAff.vue?vue&type=script&lang=js&"
export * from "./AccountAff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089273a2",
  null
  
)

export default component.exports